<template>
  <div
    class="
      file-cont
      hover:shadow-lg
      my-4 mx-2
      border-2
      hover:border-brand
      flex-1 flex flex-col
      max-w-xs
    "
    style="
      min-height: 24rem;
      max-height: 24rem;
      min-width: 16rem;
      max-width: 16rem;
    "
    :class="file_selected"
    v-click-outside="onClickOutside"
  >
    <div class="img-container overflow-hidden relative flex-auto">
      <!-- ML Loading indicator -->
      <div class="loading-indicator absolute inset-0" v-if="is_ml_processing">
        <div class="w-full h-full flex justify-center items-center">
          <span>
            <i class="fa fa-circle-notch fa-spin"></i> Processing Tags
          </span>
        </div>
      </div>
      <div class="checkbox absolute inset-x-0 top-0 z-10" v-if="checkbox">
        <button
          class="py-2 px-3 rounded-full mt-4 ml-4 shadow hover:bg-brand"
          @click.prevent="selectCheckbox($event)"
          :class="{ 'bg-brand': is_checked, 'bg-white': !is_checked }"
        >
          <i class="fa fa-check text-white"></i>
        </button>
      </div>
      <div
        class="img m-2 border border-grey h-full flex items-center relative"
        @click="singleClick($event)"
        @dblclick="doubleClick($event)"
        ref="tap_area"
      >
        <span
          class="
            absolute
            bg-orange-lighter
            w-full
            top-0
            right-0
            text-center
            transform
            py-2
            font-semibold
            text-xs
            uppercase
          "
          style="transform: rotate(45deg) translateX(30%) translateY(-100%)"
          v-if="file.is_duplicate"
          >Possible Duplicate</span
        >
        <!-- The API no longer checks S3 for the thumbnail; a missing one falls back here -->
        <img class="w-full" :src="file.thumbnail_url" :alt="file.filename" @error="useDefaultThumbnail" />
      </div>

      <div
        class="
          overlay
          bg-white
          absolute
          top-0
          w-full
          h-full
          border-b-4 border-brand
          z-20
        "
        :class="{ invisible: !open_action_btn }"
      >
        <ul class="flex flex-col h-full">
          <li class="flex flex-grow">
            <a
              href="#"
              class="
                flex-grow flex flex-row
                justify-start
                px-4
                items-center
                group
                hover:bg-brand hover:text-white
                no-underline
                text-black
                font-medium
              "
              @click.prevent="view"
              v-is-authorized="{
                roles: [$store.getters.getUserRole],
                permissions: ['can_view_info'],
              }"
            >
              <span class="fa-stack fa-lg mr-2">
                <i
                  class="
                    fa fa-circle fa-stack-2x
                    text-brand
                    group-hover:text-white
                  "
                ></i>
                <i
                  class="
                    fa fa-expand fa-stack-1x fa-inverse
                    text-white
                    group-hover:text-grey-darkest
                  "
                ></i>
              </span>
              View
            </a>
          </li>
          <li class="flex flex-grow">
            <a
              @click.prevent="download"
              href="#"
              :download="download"
              target="_blank"
              class="
                flex-grow flex flex-row
                justify-start
                px-4
                items-center
                group
                hover:bg-brand hover:text-white
                no-underline
                text-black
                font-medium
              "
              v-is-authorized="{
                roles: [$store.getters.getUserRole],
                permissions: ['can_download'],
              }"
            >
              <span class="fa-stack fa-lg mr-2">
                <i
                  class="
                    fa fa-circle fa-stack-2x
                    text-brand
                    group-hover:text-white
                  "
                ></i>
                <i
                  class="
                    fa fa-download fa-stack-1x fa-inverse
                    text-white
                    group-hover:text-grey-darkest
                  "
                ></i>
              </span>
              Download
            </a>
          </li>
          <!-- <li class="flex flex-grow"
                        v-is-authorized="{ roles: [$store.getters.getUserRole], permissions: ['can_archive'] }">
                        <a @click.prevent="$refs.archive_file_confirm.open()" href="#" class="flex-grow flex flex-row justify-start px-4 items-center group hover:bg-brand hover:text-white no-underline text-black font-medium">
                            <span class="fa-stack fa-lg mr-2">
                                <i class="fa fa-circle fa-stack-2x text-brand group-hover:text-white"></i>
                                <i class="fa fa-archive fa-stack-1x fa-inverse text-white group-hover:text-grey-dark"></i>
                            </span>
                            Archive
                        </a>
          </li>-->
          <li
            class="flex flex-grow border-t border-grey"
            v-is-authorized="{
              roles: [$store.getters.getUserRole],
              permissions: [getCurrentStateFilePermissions()],
            }"
          >
            <a
              @click.prevent="deleteFileConfirm"
              href="#"
              class="
                flex-grow flex flex-row
                justify-start
                px-4
                items-center
                group
                hover:bg-red hover:text-white
                bg-grey-light
                text-red
                no-underline
                font-medium
              "
            >
              <span class="fa-stack fa-lg mr-2">
                <i
                  class="
                    fa fa-circle fa-stack-2x
                    text-red
                    group-hover:text-white
                  "
                ></i>
                <i
                  class="
                    fa fa-trash-alt fa-stack-1x fa-inverse
                    text-white
                    group-hover:text-red
                  "
                ></i>
              </span>
              Delete
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="
        file-info-cont
        p-3
        border-grey
        bg-blue-lightest
        group-hover:bg-brand group-hover:text-white
        relative
      "
      :class="{ 'border-t': !open_action_btn }"
    >
      <div
        class="pointer text-center absolute inset-x-0 top-0 text-brand -m-4"
        :class="{ invisible: !open_action_btn }"
      >
        <i class="fa fa-caret-down fa-2x"></i>
      </div>
      <div class="file-name relative group-hover:border-white flex">
        <!-- flex-1 + min-w-0 lets the name wrap inside the bar; pr-6 keeps it clear of the menu button -->
        <div
          class="
            font-semibold
            flex-1
            min-w-0
            h-10
            break-all
            leading-tight
            pr-6
            flex
            items-center
            overflow-hidden
          "
          :title="file.filename"
          @click="singleClick($event)"
          @dblclick="doubleClick($event)"
        >
          {{ truncate(file.filename) }}
        </div>
        <button
          type="button"
          class="
            action-btn
            absolute
            inset-y-0
            right-0
            text-brand
            px-1
            text-center
            group-hover:text-white
            text-2xl
          "
          @click.prevent="open_action_btn = !open_action_btn"
        >
          <i
            class="fa fa-ellipsis-v"
            :class="{
              'text-grey-darker': !is_checked,
              'text-white': is_checked,
            }"
          ></i>
        </button>
      </div>
    </div>

    <sweet-modal icon="warning" overlay-theme="dark" ref="archive_file_confirm">
      <div class="flex flex-col">
        <span>Are you sure you want to archive this file?</span>

        <span class="text-red text-xs font-medium"
          >The file will be temporary unavailable once archived</span
        >

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click.prevent="archiveFile()"
          >
            Yes
          </button>
          <button
            class="
              border
              bg-grey-lighter
              p-4
              w-32
              text-black
              border-grey
              rounded
              font-medium
            "
            @click="$refs.archive_file_confirm.close()"
          >
            No
          </button>
        </div>
      </div>
    </sweet-modal>

    <sweet-modal icon="warning" overlay-theme="dark" ref="delete_file_confirm">
      <div class="flex flex-col">
        <span>Are you sure you want to delete this document?</span>
        <span class="text-red text-xs font-medium"
          >This document will be deleted permanently</span
        >

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click.prevent="deleteFile()"
          >
            Yes
          </button>
          <button
            class="
              border
              bg-grey-lighter
              p-4
              w-32
              text-black
              border-grey
              rounded
              font-medium
            "
            @click="$refs.delete_file_confirm.close()"
          >
            No
          </button>
        </div>
      </div>
    </sweet-modal>

    <sweet-modal
      ref="processing_request"
      overlay-theme="dark"
      hide-close-button
    >
      <div class="mt-4">
        <p class="text-6xl text-grey-dark">
          <i class="fa fa-spin fa-circle-notch"></i>
        </p>
        Please wait...
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: [
    "file",
    "selected-files",
    "checkbox",
    "get-file-info",
    "is-first",
    "is-last",
  ],

  data() {
    return {
      parent_component: null,
      open_action_btn: false,
      is_checked: false,
      is_ml_processing: false,

      download_url: "",
    };
  },

  mounted() {
    if(this.$parent.$options && this.$parent.$options.name) {
      this.parent_component = this.$parent.$options.name;
    }

    this.initEcho();
    this.initTapGesture();

    this.$ebus.$on("open-next", (payload) => {
      if (payload.file.id == this.file.id) {
        this.$ebus.$emit("close-file-view-modal");
        _.delay(() => {
          this.view();
          this.$ebus.$emit("apply-paginate", payload.paginate);
        }, 1000);
      }
    });

    this.is_ml_processing = this.file.is_ml_processing;
    this.refreshLoadingFile();
  },

  computed: {
    date_uploaded() {
      let this_date = moment(this.file.created_at);
      return this_date.format("YY-MM-DD");
    },
    file_size() {
      if (this.file.size == 0) return "0 Bytes";
      var k = 1000,
        dm = 2 || 2,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(this.file.size) / Math.log(k));
      return (
        parseFloat((this.file.size / Math.pow(k, i)).toFixed(dm)) + sizes[i]
      );
    },
    file_selected() {
      let this_class = [];
      this.is_checked = false;

      if (this.isSelected) {
        this.is_checked = true;
        this_class.push("file-selected");
      }

      return this_class;
    },
    isSelected() {
      return !_.isUndefined(
        _.find(this.selectedFiles, {
          id: this.file.id,
        })
      );
    },
    ...mapGetters({
      role: "getUserRole",
    }),
  },

  methods: {
    useDefaultThumbnail(event) {
      const fallback = "/images/default-thumbnail.png";
      if (!event.target.src.endsWith(fallback)) {
        event.target.src = fallback;
      }
    },

    // use to refresh file that still processing ML
    refreshLoadingFile() {
      if (this.is_ml_processing) {
        let interval = setInterval(() => {
          axios
            .get(`api/vaults/${this.file.vault_id}/files/${this.file.id}`)
            .then((response) => {
              if (response && response.data) {
                this.is_ml_processing = response.data.is_ml_processing;
                if (!this.is_ml_processing) {
                  clearInterval(interval);
                }
              }
            });
        }, 3000);
      }
    },
    initTapGesture() {
      var timeout;
      var lastTap = 0;
      let tap_area = this.$refs.tap_area;
      tap_area.addEventListener("touchend", (event) => {
        var currentTime = new Date().getTime();
        var tapLength = currentTime - lastTap;
        clearTimeout(timeout);
        if (tapLength < 500 && tapLength > 0) {
          this.view(event);
          event.preventDefault();
        } else {
          timeout = setTimeout(function () {
            clearTimeout(timeout);
          }, 500);
        }
        lastTap = currentTime;
      });
    },
    selectCheckbox(e) {
      this.is_checked = true;
      this.singleClick(e);
    },
    truncate(filename) {
      return _.truncate(filename, { length: 30 });
    },
    singleClick(e) {
      this.click_delay = _.delay(() => {
        if (!this.doubleclicked) {
          this.select(e);
        }
        this.doubleclicked = false;
      }, 200);
    },
    select(e) {
      let found_active_element = false;

      _.forEach(e.path, (value) => {
        if (value.classList == "active-element") {
          found_active_element = true;
          return false;
        }
      });

      if (found_active_element) {
        e.stopPropagation();
      } /* if (e.path[0].classList[0] != 'active-list')*/ else {
        e.stopPropagation();
        if (e.shiftKey || this.is_checked || e.ctrlKey || e.metaKey) {
          if (this.isSelected) {
            this.$emit("deselect-checkbox", this.file);
          } else {
            this.$emit("select-checkbox", this.file);
          }
        } else {
          if (this.isSelected) {
            this.$emit("deselect", this.file);
          } else {
            this.$emit("select", this.file);
          }
        }
      }
    },
    doubleClick(e) {
      clearTimeout(this.click_delay);
      this.$emit("select-checkbox", this.file);
      this.doubleclicked = true;
      this.view(e);
    },
    view(e) {
      axios
        .get(`api/vaults/${this.file.vault_id}/files/${this.file.id}`)
        .then((resp) => {
          let paginate = {
            prev: true,
            next: true,
          };
          if (this.isFirst) {
            paginate = {
              prev: false,
              next: true,
            };
            this.$ebus.$emit("apply-paginate", paginate);
          } else if (this.isLast) {
            paginate = {
              prev: true,
              next: false,
            };
            this.$ebus.$emit("apply-paginate", paginate);
          } else {
            this.$ebus.$emit("apply-paginate", paginate);
          }
          if (resp.data && resp.data.id) {
            this.$ebus.$emit("view-file", resp.data);
          }
        })
        .catch(({ response }) => {
          if (response && response.data) {
            let data = response.data;
            if (!data.success) {
              if (response.status == 404) {
                this.$noty.error(
                  "Error on Viewing: File not found, removed from File and Tag!"
                );
                this.$ebus.$emit("404-file", this.file);
              } else {
                this.$noty.error(data.message);
              }
            }
          }
        });
    },
    viewOcr() {
      this.$ebus.$emit("view-ocr", this.file);
    },
    download() {
      axios
        .get(
          `api/vaults/${this.file.vault_id}/files/${this.file.id}/download-path`,
          {
            params: {
              is_download: 1,
            },
          }
        )
        .then((resp) => {
          this.download_url = resp.data.url;
          window.location.href = this.download_url;
        })
        .catch(({ response }) => {
          let data = response.data;
          if (!data.success) {
            if (response.status == 404) {
              this.$noty.error(
                "Error on Downloading: File not found, removed from view!"
              );
              this.$ebus.$emit("404-file", this.file);
              this.$refs.view_file.close();
            } else {
              this.$noty.error(data.message);
            }
          }
        });
    },
    archiveFile() {
      this.$refs.archive_file_confirm.close();
      this.$refs.processing_request.open();
      let data = {
        headers: {
          Accept: "application/json",
        },
      };
      axios
        .delete(`/api/vaults/${this.file.vault_id}/files/${this.file.id}`, data)
        .then((response) => {
          let data = response.data;
          this.$refs.processing_request.close();
          this.$ebus.$emit("archived-from-file");
          this.$emit("refresh-files", "file-archived");
          this.$ebus.$emit("refresh-vaults");
          this.$noty.success(`${this.file.filename} has been archived!`, {
            killer: true,
            timeout: 1500,
          });
        })
        .catch((error) => {
          //put a better alert later
          alert("The file could not be archived");
          console.log(error);
        });
    },
    updateFile(type) {
      axios
        .get(`api/vaults/${this.file.vault_id}/files/${this.file.id}`)
        .then((resp) => {
          if (type == "thumbnail-generated") {
            this.file.thumbnail_url = resp.data.thumbnail_url;
          }
        });
    },
    initEcho() {
      window.Echo.private("ingest-events-file-" + this.file.id).listen(
        ".thumbnail-generated",
        (data) => {
          this.updateFile("thumbnail-generated");
        }
      );
    },
    onClickOutside() {
      this.open_action_btn = false;
    },
    deleteFileConfirm() {
      if (this.file.is_filed) {
        if (!_.includes(["userA", "userB"], this.role)) {
          this.$noty.warning(
            `You don't have access to delete this file ${this.file.filename}!`,
            {
              killer: true,
              timeout: 1500,
            }
          );
        } else {
          this.$refs.delete_file_confirm.open();
        }
      } else {
        this.$refs.delete_file_confirm.open();
      }
    },
    deleteFile() {
      this.$refs.delete_file_confirm.close();
      this.$refs.processing_request.open();
      axios
        .delete(`api/vaults/${this.file.vault_id}/files/${this.file.id}`)
        .then(({ data }) => {
          if (data) {
            if(this.parent_component && this.parent_component == 'SearchDocuments') {
              this.$ebus.$emit("remove-as-selected", this.file);
            }

            // this.deletePermanently();
            this.$emit("refresh-files", "file-deleted");
            this.$ebus.$emit("update-unfiled");

            if(!this.parent_component || this.parent_component != 'SearchDocuments') {
              this.$ebus.$emit("deleted-from-file");
            }

            this.$ebus.$emit("refresh-vaults");
            this.$refs.processing_request.close();
            this.$noty.success(`${this.file.filename} has been deleted!`, {
              killer: true,
              timeout: 1500,
            });
          }
        });
    },
    deletePermanently() {
      axios
        .delete(`api/vaults/${this.file.vault_id}/files/${this.file.id}`, {
          params: {
            permanent_delete: 1,
          },
        })
        .then(({ data }) => {
          if (data) {
            this.$emit("refresh-files", "file-deleted");
            this.$ebus.$emit("update-unfiled");
            this.$ebus.$emit("deleted-from-file");
            this.$ebus.$emit("refresh-vaults");
            this.$refs.processing_request.close();
            this.$noty.success(`${this.file.filename} has been deleted!`, {
              killer: true,
              timeout: 1500,
            });
          }
        });
    },
    getCurrentStateFilePermissions() {
      if (this.file.is_filed) {
        return "can_delete_document_after_filing";
      } else {
        return "can_delete_document_before_filing";
      }
    },
  },
};
</script>

<style scoped>
.loading-indicator {
  background: rgba(218, 222, 231, 0.7);
}
</style>
